import { render, staticRenderFns } from "./drawtemplate.vue?vue&type=template&id=57a5a66a&scoped=true&"
import script from "./drawtemplate.vue?vue&type=script&lang=js&"
export * from "./drawtemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a5a66a",
  null
  
)

export default component.exports